import React, { useState } from "react";
import cn from "classnames";

const CORRECT_PIN = process.env.REACT_APP_CORRECT_PIN; // Fallback pin if env not set

export default function PinScreen({ onSuccess }) {
  const [pin, setPin] = useState("");
  const [error, setError] = useState(false);

  const handleNumberClick = (num) => {
    if (pin.length < 4) {
      const newPin = pin + num;
      setPin(newPin);
      setError(false);

      if (newPin.length === 4) {
        if (newPin === CORRECT_PIN) {
          onSuccess();
        } else {
          setError(true);
          setPin("");
        }
      }
    }
  };

  const handleDelete = () => {
    setPin(pin.slice(0, -1));
    setError(false);
  };

  return (
    <div className="fixed inset-0 bg-neutral-5 flex flex-col items-center justify-center gap-8 z-50">
      <div className="flex gap-4 mb-8">
        {[...Array(4)].map((_, i) => (
          <div 
            key={i} 
            className={cn("w-10 h-10 border-2 border-neutral-30 rounded-lg flex items-center justify-center text-2xl text-neutral-80", {
              "border-red-500 animate-[shake_0.5s]": error
            })}>
            {pin[i] ? "•" : ""}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-4 max-w-[300px] w-full p-4">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
          <button 
            key={num} 
            onClick={() => handleNumberClick(num)}
            className="bg-neutral-15 rounded-lg text-neutral-80 text-2xl p-4 cursor-pointer transition-colors hover:bg-neutral-20 active:bg-neutral-30"
          >
            {num}
          </button>
        ))}
        <button 
          onClick={handleDelete}
          className="bg-neutral-15 rounded-lg text-neutral-80 text-2xl p-4 cursor-pointer transition-colors hover:bg-neutral-20 active:bg-neutral-30"
        >
          ←
        </button>
        <button 
          onClick={() => handleNumberClick(0)}
          className="bg-neutral-15 rounded-lg text-neutral-80 text-2xl p-4 cursor-pointer transition-colors hover:bg-neutral-20 active:bg-neutral-30"
        >
          0
        </button>
      </div>
      {error && <div className="text-red-500 mt-4">Incorrect PIN</div>}
    </div>
  );
} 